module.exports = __webpack_public_path__ + "img/weddings_08_V.97543f57.jpg";